<template>
  <section class="modalImg">
    <div class="modalImg__card">
      <button
        class="modalImg__close"
        @keydown.esc="clearModalToShow"
        @click="clearModalToShow"
      >
        <icon
          icon="Close"
        />
      </button>
      <img
        v-if="!isPdf"
        class="modalImg__card__img"
        :src="urlImg"
      >
      <embed
        v-else
        class="modalImg__card__pdf"
        :src="urlImg"
      >
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'ModalImg',
  computed: {
    ...mapGetters([
      'showModal',
    ]),
    urlImg() {
      return URL.createObjectURL(this.showModal.file);
    },
    isPdf() {
      return this.showModal.file.type === 'application/pdf';
    }
  },
  methods: {
    ...mapActions([
      'clearModalToShow'
    ]),
  }
};
</script>

<style lang="scss" scoped>
  /* The Modal (background) */
  .modalImg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    &__card {
      height: auto;
      border-radius: 0.5rem;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      row-gap: 1rem;

      &__img {
        height: 100%;
        padding: 0 1.5rem;
        display: block;
      }

      &__pdf {
        height: 90vh;
        width: 90vw;
        padding: 0 1.5rem;
      }
    }

    &__close {
      color: $white;
      margin-right: 1.5rem;
    }
  }
</style>